export enum ReportStatus {
  InProgress = 'InProgress',
  Created = 'Created',
  Failed = 'Failed'
}
